import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-arena-cash-nav',
  templateUrl: './arena-cash-nav.component.html',
  styleUrls: ['./arena-cash-nav.component.scss']
})
export class ArenaCashNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
